import EnvironmentConfig from '../interfaces/EnvironmentConfig'

const e2eQaConfigs: EnvironmentConfig = {
    dashboardUrl: 'https://dashboard.qa.casaretail.ai',
    onboardingDashboardUrl: 'https://onboarding.qa.casaretail.ai',
    ruleServerUrl: 'https://kapi.qa.casaretail.ai',
    apiServerUrl: 'https://kapi.qa.casaretail.ai', // TODO: Need to change
    redmineUrl: 'https://redmine.casaretail.ai',
    casaWebAppUrl: 'https://web.qa.casaretail.ai',
    casaEcomUrl: 'https://ecom.qa.casaretail.ai',
    casaBeatUrl: 'https://beat-api.qa.casaretail.ai',
    turnedOffFeatures: [],
    keycloakConfig: {
        url: `https://qa.auth.ginesys.one/auth`,
        realm: `GinesysOne`,
        clientId: `GinesysOne`,
    },
    ruleUiUrl: 'https://rules.casaqa.ajira.tech',
    financeOnboarding: {
        webhookUrl: 'https://n8n.casaqa.ajira.tech/webhook/finance-onboarding',
        submitToken: 'fb4yOjDdof5q5v9N4i8zKERMKtDKf0Jo',
        recaptchaSiteKey: '6Lc17oEtAAAAAMnqd0yW_XEbjn0K1m5eF13sOF9z',
    },
}

export default e2eQaConfigs
